module.exports = __webpack_public_path__ + "static/media/logo.d36b8b8a.png";